export default __webpack_public_path__ + "deepseek-iconbd09da.png";